export enum TemplateFormFieldEnum {
  BOOLEAN = 'BOOLEAN',
  STRING = 'STRING',
  LONG = 'LONG',
  PASSWORD = 'PASSWORD',
  SSH = 'SSH',
  SSL = 'SSL',
  SOURCE_NAME = 'SOURCE_NAME',
  DESTINATION_NAME = 'DESTINATION_NAME',
  TOGGLE = 'TOGGLE',
  DROPDOWN = 'DROPDOWN',
  RADIO_GROUP = 'RADIO_GROUP',
  AUTHORIZATION_BUTTON = 'AUTHORIZATION_BUTTON',
  SYSTEM_GENERATED = 'SYSTEM_GENERATED',
  FILE_PICKER = 'FILE'
}
